import ManageAsset from '../components/Assets/ManageAsset';
import { useAssets } from '../hooks/useAssets';
import Loading from '../components/general/Loading';
import AddAsset from '../components/Assets/AddAsset';
import { useEffect, useState } from 'react';
import { setBatteryObject, setGeneratorObject } from '../helpers/Assets';
import {
  deletebattery,
  deleteGenerator,
  patchBattery,
  patchGenerator,
  postBattery,
  postGenerator,
} from '../services/assetService';
import {
  assetTypeBattery,
  assetTypeGenerator,
  initialBattery,
  initialGenerator,
} from '../Constants';
import { getInputFields } from '../helpers/getInputFields';

/**
 * The admin page
 *
 * @return {JSX.Element}
 */
export default function Admin() {
  const [generators, setGenerators] = useState({
    gasGenerators: [],
    dieselGenerators: [],
  });
  const [batteries, setBatteries] = useState([]);
  const { data: generatorData, isLoading: generatorsLoading } = useAssets(assetTypeGenerator);
  const { data: batteryData, isLoading: batteriesLoading } = useAssets(assetTypeBattery);

  useEffect(() => {
    if (generatorData) {
      setGenerators(generatorData);
    }
  }, [generatorData]);

  useEffect(() => {
    if (batteryData) {
      setBatteries(batteryData);
    }
  }, [batteryData]);

  return (
    <div className="col-span-12">
      {generatorsLoading ? (
        <Loading />
      ) : (
        <section className="shadow-micro bg-white rounded-lg py-6 px-4 sm:p-10 mb-6">
          <h1 className="text-2xl leading-6 font-medium pb-2 mb-6 uppercase">Generators</h1>

          <h3 className="text-xl mb-2 mt-6">Gas generators</h3>
          {generators?.gasGenerators?.map(generator => {
            const inputFields = getInputFields(assetTypeGenerator, generator);
            return (
              <ManageAsset
                key={generator.id}
                assetObject={generator}
                setAssets={setGenerators}
                inputFields={inputFields}
                setAssetObject={setGeneratorObject}
                assetLabel={assetTypeGenerator}
                patchAsset={patchGenerator}
                deleteAsset={deleteGenerator}
              />
            );
          })}

          <h3 className="text-xl mb-2 mt-6">Diesel generators</h3>
          {generators?.dieselGenerators?.map(generator => {
            const inputFields = getInputFields(assetTypeGenerator, generator);
            return (
              <ManageAsset
                key={generator.id}
                assetObject={generator}
                setAssets={setGenerators}
                inputFields={inputFields}
                setAssetObject={setGeneratorObject}
                assetLabel={assetTypeGenerator}
                patchAsset={patchGenerator}
                deleteAsset={deleteGenerator}
              />
            );
          })}

          <AddAsset
            setAssets={setGenerators}
            setAssetObject={setGeneratorObject}
            initialAsset={initialGenerator}
            assetLabel={assetTypeGenerator}
            postAsset={postGenerator}
          />
        </section>
      )}
      {batteriesLoading ? (
        <Loading />
      ) : (
        <section className="shadow-micro bg-white rounded-lg py-6 px-4 sm:p-10 mb-6">
          <h1 className="text-2xl leading-6 font-medium pb-2 mb-6 uppercase">Batteries</h1>
          {batteries.map(battery => {
            const inputFields = getInputFields(assetTypeBattery, battery);
            return (
              <ManageAsset
                key={battery.id}
                assetObject={battery}
                setAssets={setBatteries}
                inputFields={inputFields}
                setAssetObject={setBatteryObject}
                assetLabel={assetTypeBattery}
                patchAsset={patchBattery}
                deleteAsset={deletebattery}
              />
            );
          })}

          <AddAsset
            setAssets={setBatteries}
            setAssetObject={setBatteryObject}
            initialAsset={initialBattery}
            assetLabel={assetTypeBattery}
            postAsset={postBattery}
          />
        </section>
      )}
    </div>
  );
}
